import { render, staticRenderFns } from "./ProductTabs.vue?vue&type=template&id=02f2c802"
import script from "./ProductTabs.vue?vue&type=script&lang=js"
export * from "./ProductTabs.vue?vue&type=script&lang=js"
import style0 from "./ProductTabs.vue?vue&type=style&index=0&id=02f2c802&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports